// removed by extract-text-webpack-plugin
module.exports = {"slide":"_14h79HWXfK5OLnXL-FoY3P","compact":"_2pLqB6kwPzIkFFP8Z1KWNu","image":"_2itJS7L78ORKWFD7nhA65Y","prev":"t2JQztyzThW4FnSA2wC8o","next":"_1c8-sicpkCj8P-EWEzOyYs","featureActive":"_2xtaBL62d4hr77qwobWC9","feature":"_12HqbvqOCUph6EVHMuEBUx","timeline":"_2htS-21N7DOys0fqUHLJQx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectCardSlider/ProjectCardSlider.module.scss
// module id = 797
// module chunks = 0